/**
 * Drop everything belonging to whoever was signed in: every client's own saved
 * state and the socket-scoped data. Every client shares the sign-in
 * (docs/adr/40-every-elaso-client-shares-one-sign-in.md), so a sign-out or an
 * account switch in one client is one in all of them.
 */
export const resetAccountState = async (): Promise<void> => {
	const [{ uiStore }, { opsUiStore }, { coreStore }, { dataCacheStore }] =
		await Promise.all([
			import("./ui-store"),
			import("./ops-ui-store"),
			import("./core-store"),
			import("./data-cache-store"),
		]);
	uiStore.getState().reset();
	opsUiStore.getState().reset();
	coreStore.getState().reset();
	dataCacheStore.getState().reset();
};
